import { useTable, useSortBy } from "react-table";
import { useMemo } from "react";
import { RiArrowUpSFill, RiArrowDownSFill } from "react-icons/ri";
import { Currencies } from "../Components/Currencies";
import { useState } from "react";

export const DefaultTable = (props) => {
  const columns = useMemo(() => props.columns, [props.columns]);
  const data = useMemo(() => props.data, [props.data]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    visibleColumns,
    rows,
    prepareRow,
  } = useTable(
    {
      columns: columns,
      data: data,
    },
    useSortBy
  );

  const firstPageRows = rows.slice(0, 5);
  return (
    // <div className="bg-p-wh drop-shadow-m border-[1px] border-f-bk rounded-lg text-sm w-full">
    <table
      {...getTableProps()}
      className="w-full h-fit rounded-lg text-sm bg-p-wh shadow-lg"
    >
      <thead className="">
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()} className="">
            {headerGroup.headers?.map((column) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                className="py-4 px-6 text-center"
              >
                <div className="flex flex-row items-center gap-2 justify-center">
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <div className="flex flex-col">
                        <RiArrowUpSFill />
                        <RiArrowDownSFill className="-mt-2" />
                      </div>
                    ) : (
                      <div className="flex flex-col">
                        <RiArrowUpSFill />{" "}
                        <RiArrowDownSFill className="-mt-2" />
                      </div>
                    )}
                  </span>
                </div>
              </th>
            ))}
          </tr>
        ))}
      </thead>

      <tbody className="w-full ">
        {firstPageRows.map(
          (row, i) =>
            prepareRow(row) || (
              <tr {...row.getRowProps()} className="border-t-hf">
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      className="py-6 px-4 text-center"
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            )
        )}
      </tbody>
    </table>
    // </div>
  );
};
